// @owners { team: patient-fulfillment }
import {
  type PlansEndpointLatestRequest,
  type PlansEndpointLatestResponse,
} from '@alto/scriptdash/alto/med_sync/patients/v1/plans_endpoint';
import { get } from '~shared/helpers/apiHelper';
import { useQuery } from '~shared/react-query';

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
const fetchLatestMedSyncPlan = ({ user_id }: PlansEndpointLatestRequest): Promise<PlansEndpointLatestResponse> => {
  return get(
    `/med_sync/plans/latest`,
    {
      user_id,
    },
    {
      version: 'v1',
    },
  ).then((response) => {
    if (response.errors?.length) {
      throw new Error(response.errors);
    }
    return response;
  });
};

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
export const useFetchLatestMedSyncPlan = (user_id: number | null) => {
  const userID = Number(user_id);

  return useQuery<PlansEndpointLatestResponse>({
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @alto/prefer-query-key-factory
    queryKey: ['latest-med-sync-plan', { userID }],
    queryFn: () => fetchLatestMedSyncPlan({ user_id: userID }),
    enabled: user_id !== null,
  });
};
